import { render, staticRenderFns } from "./AppProgramaGrupoPresentacion.vue?vue&type=template&id=1040683e&scoped=true&"
import script from "./AppProgramaGrupoPresentacion.vue?vue&type=script&lang=ts&"
export * from "./AppProgramaGrupoPresentacion.vue?vue&type=script&lang=ts&"
import style0 from "./AppProgramaGrupoPresentacion.vue?vue&type=style&index=0&id=1040683e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040683e",
  null
  
)

export default component.exports